import { render, staticRenderFns } from "./UserContributions.vue?vue&type=template&id=4ba82ea6&scoped=true&"
import script from "./UserContributions.vue?vue&type=script&lang=js&"
export * from "./UserContributions.vue?vue&type=script&lang=js&"
import style0 from "./UserContributions.vue?vue&type=style&index=0&id=4ba82ea6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba82ea6",
  null
  
)

export default component.exports